module.exports = __webpack_public_path__ + "img/regular_lease_process03.88c3b9c0.png";